import React, { useState, useEffect } from "react";
import { fetchPages } from "../services/shopifyService";
import "../App.css";

const Pages = ({ set, shop, onStoreData, data }) => {
  const [products, setProducts] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [selectedPageIds, setSelectedPageIds] = useState(new Set());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchPages(shop, keyword);
        setProducts(response.pages);
        console.log("Data retrieved successfully1:", response.products);
      } catch (error) {
        console.error("Error retrieving data:", error);
      }
    };

    fetchData();
  }, [shop, keyword]);

  useEffect(() => {
    try {
      if (data) {
        console.log("Raw data received:", data);
        // Check if data is a string
        if (typeof data === "string") {
          const firstParse = JSON.parse(data); // First parse
          console.log("First Parse:", firstParse);

          const parsedData = Array.isArray(firstParse)
            ? firstParse
            : JSON.parse(firstParse); // Second parse if needed
          console.log("Parsed Data:", parsedData);
          console.log("Type of Parsed Data:", typeof parsedData);

          if (Array.isArray(parsedData)) {
            console.log("Selected Products from Data:", parsedData);
            const productIdsSet = new Set(parsedData.map((id) => String(id)));
            console.log("Product IDs Set created:", productIdsSet);
            setSelectedPageIds(productIdsSet);
          } else {
            console.warn("Parsed data is not an array, it is:", parsedData);
            setSelectedPageIds(new Set());
          }
        } else {
          console.warn("Data is not a string:", data);
          setSelectedPageIds(new Set());
        }
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
      setSelectedPageIds(new Set());
    }
  }, [data]);

  const handleInputChange = (value) => {
    setKeyword(value);
  };

  const handleCheckboxChange = (id) => {
    setSelectedPageIds((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(String(id))) {
        newSelected.delete(String(id));
      } else {
        newSelected.add(String(id));
      }
      console.log("Checkbox changed, newSelected:", newSelected);
      return newSelected;
    });
  };

  const handleStoreData = () => {
    setLoading(true);

    const selectedPageIdsArray = Array.from(selectedPageIds);
    console.log("Selected product IDs to store:", selectedPageIdsArray);

    const jsonPayload = JSON.stringify(selectedPageIdsArray);

    if (onStoreData) {
      onStoreData(jsonPayload);
    }

    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  return (
    <div className="modal-container">
      <div className="modal-middle">
        <div className="modal-header">
          <h4>Add Pages</h4>
          <button onClick={() => set(false)}>X</button>
        </div>
        <div className="search-container">
          <input
            type="search"
            name="keyword"
            onChange={(e) => handleInputChange(e.target.value)}
            placeholder="Search Pages"
          />
        </div>
        <div className="product-list">
          {products.length > 0 ? (
            products.map((product) => (
              <div key={product.id} className="search-row">
                <input
                  type="checkbox"
                  id={product.id}
                  checked={selectedPageIds.has(String(product.id))}
                  onChange={() => handleCheckboxChange(String(product.id))}
                />
                <label htmlFor={product.id}>{product.title}</label>
               
              </div>
            ))
          ) : (
            <p>No pages found</p>
          )}
        </div>
        {loading && <div className="loading">Loading...</div>}
        <div className="modal-footer">
          <button onClick={handleStoreData} disabled={loading}>
            Store Data
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pages;
